const yodaCoreComponents = {
    NavigationHelper: {
        importFn: () => import('yodaCoreComponents/NavigationHelper'),
        path: 'yodaCoreComponents/NavigationHelper',
        type: 'utility',
        isSSR: false,
    },
};

module.exports = { yodaCoreComponents };
